var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgPiece24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M11.998 22c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.645 16.1a1 1 0 0 1-1-1v-.037a1 1 0 0 1 .221-.628l3.956-4.9a.046.046 0 0 0-.036-.076H9.707a.922.922 0 1 1 0-1.843h4.906a1 1 0 0 1 1 1v.173a1 1 0 0 1-.21.613l-3.702 4.78a.047.047 0 0 0 .037.075h3.094a.922.922 0 0 1 0 1.843H9.645Z"
  })));
});
SvgPiece24.displayName = "SvgPiece24";
export default SvgPiece24;